import React from "react";
import styles from "./AccessDeniedPage.module.scss"
import {useTranslation} from "react-i18next";

export default function AccessDeniedPage() {
    const {t} = useTranslation();
    return (
        <div className={"text-center"}>
            <div className={styles.wrapper}>
                <h1 className={styles.titleText}>{t("ERROR_AccessDenied")}</h1>
                <p className={styles.topText}>{t("ERROR_AccessDeniedMessage")}</p><a className={styles.email}
                   href={"mailto:flintlinksupport@flintlink.com"}>flintlinksupport@flintlink.com</a>
                <p className={styles.bottomText}>{t("ERROR_AccessDeniedFootText")}</p>
            </div>
        </div>
    )
}